import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useVendorAuth } from "../store/vendorAuthStore";

export default function ProtectedVendorRoute({ children }) {
  const { token } = useVendorAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}